export const automationTranslations = {
  en: {
    hero: {
      badge: 'Custom Automation Solutions',
      title: 'Custom-designed assembly and testing stations.',
      subtitle: 'Flexible integration for medium-size projects with competitive lead times and reliable industrial performance.',
      cta1: 'Request Technical Proposal',
      cta2: 'Schedule a Call',
      trust1: 'PLC integration',
      trust2: 'Vision systems',
      trust3: 'Leak Test certified'
    },
    solutions: {
      title: 'Automation &',
      titleAccent: 'Testing Solutions',
      items: [
        'Electrical testing stations',
        'Leak Test stations',
        'Hermeticity validation for sealed connectors and components',
        'Integration of industry-leading leak testers',
        'Semi-automatic assembly stations',
        'Functional testing stations',
        'Hybrid lines (manual + automatic)',
        'PLC integration: Mitsubishi, Siemens, Keyence',
        'Machine vision integration',
        'Custom electrical and pneumatic devices'
      ]
    },
    applications: {
      title: 'Typical',
      titleAccent: 'Applications',
      items: [
        'Electrical validation for connectors and subassemblies',
        'Leak Test for sealing and IP-rated components',
        'Assembly of electrical and mechanical modules',
        'High-volume compact testing stations',
        'Integrated test systems for existing production lines',
        'NPI and pre-production systems',
        'Functional performance testing'
      ]
    },
    advantages: {
      title: 'Why Choose',
      titleAccent: 'DSI',
      items: [
        'Mechanical + electrical + CNC manufacturing in one facility',
        'Faster and more flexible than large international integrators',
        'More specialized than generic automation shops',
        'Full development cycle: concept → 3D design → CNC → integration → validation',
        'Robust systems designed for continuous industrial operation',
        'Proven experience in automotive and electrical component manufacturing',
        'Technical support throughout installation and operation'
      ]
    },
    process: {
      title: 'Our Engineering',
      titleAccent: 'Process',
      steps: [
        'Requirement analysis',
        'Concept and technical proposal',
        'Mechanical & electrical 3D design',
        'CNC manufacturing and assembly',
        'Programming and functional testing',
        'Installation, validation, and support'
      ]
    },
    midCta: {
      title: 'Need a custom assembly or testing station?',
      button1: 'Request Proposal',
      button2: 'Schedule a Call'
    },
    gallery: {
      title: 'Examples of',
      titleAccent: 'Integrated Stations',
      images: [
        {
          title: 'Automated Testing Station',
          caption: 'PLC-controlled test station - Vision system integration - Real-time data logging'
        },
        {
          title: 'Assembly Automation Cell',
          caption: 'Semi-automated assembly system - Pneumatic actuators - Quality verification sensors'
        },
        {
          title: 'Inspection & Sorting System',
          caption: 'Automated quality control station - Machine vision - Pass/Fail sorting mechanism'
        }
      ]
    },
    finalCta: {
      title: 'Ready to upgrade your',
      titleAccent: 'manufacturing process?',
      button1: 'Request Technical Proposal',
      button2: 'Contact DSI'
    }
  },
  es: {
    hero: {
      badge: 'Soluciones de Automatización a Medida',
      title: 'Estaciones y celdas de ensamble y prueba diseñadas a la medida.',
      subtitle: 'Integración flexible para proyectos medianos con tiempos de entrega competitivos y alto desempeño industrial.',
      cta1: 'Solicitar propuesta técnica',
      cta2: 'Agendar videollamada',
      trust1: 'Integración PLC',
      trust2: 'Sistemas de visión',
      trust3: 'Leak Test certificado'
    },
    solutions: {
      title: 'Soluciones de',
      titleAccent: 'automatización y prueba',
      items: [
        'Estaciones de prueba eléctrica',
        'Estaciones de prueba de fugas (Leak Test)',
        'Validación de hermeticidad para conectores y componentes sellados',
        'Integración de probadores de marcas líderes del mercado',
        'Estaciones de ensamble semiautomático',
        'Pruebas funcionales',
        'Líneas híbridas (manual + automático)',
        'Integración PLC: Mitsubishi, Siemens, Keyence',
        'Integración de sistemas de visión industrial',
        'Dispositivos eléctricos y neumáticos a la medida'
      ]
    },
    applications: {
      title: 'Aplicaciones',
      titleAccent: 'típicas',
      items: [
        'Prueba eléctrica de conectores y subconjuntos',
        'Pruebas de fugas para garantizar estanqueidad (hermeticidad)',
        'Ensamble de módulos eléctricos y mecánicos',
        'Validación funcional de componentes',
        'Estaciones compactas para alto volumen',
        'Integración de pruebas dentro de líneas existentes',
        'Equipos para NPI, prototipos y ramp-up de producción'
      ]
    },
    advantages: {
      title: 'Ventajas',
      titleAccent: 'competitivas',
      items: [
        'Ingeniería mecánica + eléctrica + CNC en una sola empresa',
        'Lead times más cortos que integradores transnacionales',
        'Más especializados que talleres de automatización genéricos',
        'Desarrollo completo: concepto → diseño 3D → manufactura CNC → integración → validación',
        'Equipos robustos diseñados para operación continua',
        'Experiencia comprobada en proyectos automotrices y eléctricos',
        'Soporte técnico post–instalación'
      ]
    },
    process: {
      title: 'Nuestro',
      titleAccent: 'proceso',
      steps: [
        'Análisis del requerimiento',
        'Concepto y propuesta técnica',
        'Diseño 3D mecánico y eléctrico',
        'Manufactura CNC e integración de componentes',
        'Programación y pruebas funcionales',
        'Instalación, validación y soporte'
      ]
    },
    midCta: {
      title: '¿Necesitas diseñar una estación de ensamble o prueba?',
      button1: 'Solicitar propuesta técnica',
      button2: 'Agendar videollamada'
    },
    gallery: {
      title: 'Ejemplos de',
      titleAccent: 'estaciones y dispositivos integrados',
      images: [
        {
          title: 'Estación de Prueba Automatizada',
          caption: 'Estación de prueba controlada por PLC - Integración de sistema de visión - Registro de datos en tiempo real'
        },
        {
          title: 'Celda de Automatización de Ensamble',
          caption: 'Sistema de ensamble semi-automatizado - Actuadores neumáticos - Sensores de verificación de calidad'
        },
        {
          title: 'Sistema de Inspección y Clasificación',
          caption: 'Estación de control de calidad automatizada - Visión artificial - Mecanismo de clasificación Pasa/No pasa'
        }
      ]
    },
    finalCta: {
      title: 'Transformemos tu proceso con una',
      titleAccent: 'solución a la medida',
      button1: 'Solicitar propuesta técnica',
      button2: 'Contactar a DSI'
    }
  }
};